function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PositionVariants as t } from "./index.es172.js";
var e = 8,
  r = 7,
  n = {
    x: 15,
    y: -4
  },
  s = 4.5,
  f = {
    top: 0,
    left: 0,
    triangleOffset: {
      transform: "rotate(45deg)"
    }
  },
  i = "225deg",
  O = "-45deg",
  d = "135deg",
  l = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, t.aboveCenter, t.underCenter), t.underCenter, t.aboveCenter), t.aboveLeft, t.underLeft), t.aboveRight, t.underRight), t.underLeft, t.aboveLeft), t.underRight, t.aboveRight), t.left, t.right), t.right, t.left),
  R = {
    transform: "--vds-tooltip-transform",
    top: "--vds-tooltip-top",
    left: "--vds-tooltip-left",
    right: "--vds-tooltip-right",
    bottom: "--vds-tooltip-bottom",
    triangleOffset: {
      transform: "--vds-tooltip-before-transform",
      top: "--vds-tooltip-before-top",
      left: "--vds-tooltip-before-left",
      right: "--vds-tooltip-before-right",
      bottom: "--vds-tooltip-before-bottom"
    }
  },
  T = 250;
export { R as CSS_VARIABLES, f as DEFAULT_OFFSET, T as DELAY_BEFORE_SHOW_TOOLTIP, O as LEFT_ARROW, l as OPPOSITE_POSITION_VARIANTS, d as RIGHT_ARROW, e as TOOLTIP_X_OFFSET, r as TOOLTIP_Y_OFFSET, s as TRIANGLE_BORDER, n as TRIANGLE_OFFSETS, i as UP_ARROW };